module.exports = __webpack_public_path__ + "img/Dashboard.6c8b691c.png";